// extracted by mini-css-extract-plugin
module.exports = {"addValue":"AddValue_addValue__2MPXg","buttons":"AddValue_buttons__hV1OU","addValueButton":"AddValue_addValueButton__1r4MO"};